import type { StudentAssignmentCubit } from '@breakoutlearning/firebase-repository/cubits/StudentAssignmentCubit'
import { Dialog } from 'components/dialogs/Dialog'
import { DialogCloseButton } from 'components/dialogs/DialogCloseButton'
import { SuspenseErrorBoundary } from 'components/SuspenseErrorBoundary'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { Suspense, lazy } from 'react'

const QuizRunner = lazy(
  () => import('components/PreWorkQuizRunner/PreWorkQuizRunner')
)

const PreWorkModalBody = observer(function PreWorkModalBody({
  closeModal,
  cubit,
}: {
  closeModal: () => void
  cubit: StudentAssignmentCubit
}) {
  if (cubit.questions.isLoading) {
    return <div>Loading...</div>
  }
  // take over the screen
  return (
    <div className="fixed left-0 top-0 flex h-full w-full items-center justify-center bg-surface">
      <SuspenseErrorBoundary>
        <Suspense
          fallback={
            <>
              <DialogCloseButton />
              <div>Loading...</div>
            </>
          }
        >
          <QuizRunner cubit={cubit} closeModal={closeModal} />
        </Suspense>
      </SuspenseErrorBoundary>
    </div>
  )
})

export function QuizModal({
  cubit,
  closeModal,
}: {
  cubit: StudentAssignmentCubit
  closeModal: () => void
}) {
  const { t } = useTranslation()
  return (
    <Dialog
      size="xxl"
      ignoreBackdropClick
      testId="quiz-modal"
      aria-label={t('student_assignment.pre_session_quiz')}
      aria-labelledby={undefined}
    >
      <PreWorkModalBody closeModal={closeModal} cubit={cubit} />
    </Dialog>
  )
}
